import UsageItem from './model';

const reviver = ([key, val]) => {
  switch (key) {
    case 'allCoreActivities':
    case 'completedCoreActivities':
      return [key, `${val}`];
    default:
      return [key, val];
  }
};

const create = (data) =>
  new UsageItem(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/OnlineHomework/HFUsage/model/onlineUsage/create.js